// Calendar Block View Component (Read-only)
import React from 'react';
import { Calendar } from 'lucide-react';

const CalendarBlockView = ({ content }) => {
  const { showMonths, highlightEvents } = content || {};

  return (
    <div className="text-center py-8">
      <Calendar className="w-16 h-16 text-[#7A99D8] mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-[#3C3C3C] dark:text-gray-100 mb-2">
        Class Schedule
      </h3>
      <p className="text-gray-600 dark:text-gray-400">
        Calendar component will be rendered here showing {showMonths || 3} months of classes
      </p>
    </div>
  );
};

export default CalendarBlockView;
